//-------- 进项转出模块 --------开始
//进项转出信息分页查询
import request from './request.js';
import {requestbody} from './request.js'
import config from "../../configHttp";

export async function jxzc_jxzcInfoPage_api(params = {

}) {
    return await requestbody('/iinvout/query', 'post', params)
}

//页面初始化
export async function jxzc_initJxzcInfo_api(params = {

}) {
    return await requestbody('/iinvout/init', 'post', params)
}
//数据来源配置分页查询
export async function jxzc_dataOriginInfoPage_api(params = {

}) {
    return await requestbody('/iinvout/dataorigin/find', 'post', params)
}
//更新取数
export async function jxzc_updateIinvoutData_api(params = {

}) {
    return await requestbody('/iinvout/date/update', 'post', params)
}
//进项转出清空数据
export async function jxzc_clearNowTax_api(params = {

}) {
    return await requestbody('/iinvout/date/clear', 'post', params)
}
//过去当前实体下所有有权限的实体信息
export async function jxzc_findAllNsrinfo_api(params = {

}) {
    return await request('/iinvout/jinxzc/findAllNsrinfo', 'post', params)
}
//获取汇总统计信息
export async function jxzc_summaryShow_api(params = {

}) {
    return await requestbody('/iinvout/summary/query', 'post', params)
}
//进项转出 初始化下拉框数据
export async function jxzc_initDownData_api(params = {

}) {
    return await request('/iinvout/downlist/init', 'post', params)
}
//进项转出 修改数据来源
export async function jxzc_updateLy_api(params = {

}) {
    return await requestbody('/iinvout/dataorigin/update', 'post', params)
}
//进项转出明细登记发票查询
export async function jxzc_findDetailsFap_api(params = {

}) {
    return await requestbody('/iinvout/details/list', 'post', params)
}
//进项转出明细登记转出额清空
export async function jxzc_clearFapZce_api(params = {

}) {
    return await requestbody('/iinvout/details/clear', 'post', params)
}
//进项转出查看业务编码
export async function jxzc_chakywbm_api(params = {

}) {
    return await request('/iinvout/subject/query', 'post', params)
}
//明细登记 编辑查询
export async function jxzc_mxdjbjcx_api(params = {

}) {
    return await requestbody('/iinvout/details/query', 'post', params)
}
//明细登记保存
export async function jxzc_savemxdjbj_api(params = {

}) {
    return await requestbody('/iinvout/details/update', 'post', params)
}

//导出
export async function jxzc_login_api(params = {

}) {
    return await requestbody('/login', 'post', params)
}
